import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareReportsVelocityRoute: InvariantJiraRoute = {
	name: 'software-reports-velocity',
	path: '/jira/software/projects/:projectKey/boards/:boardId/reports/velocity',
};
